import {createAction} from 'redux-act';

export const GET_CUSTOMER_INSIGHTS = createAction(
  'customerInsights/GET_CUSTOMER_INSIGHTS'
);
export const GET_CUSTOMER_INSIGHTS_SUCCESS = createAction(
  'customerInsights/GET_CUSTOMER_INSIGHTS_SUCCESS'
);
export const GET_CUSTOMER_INSIGHTS_ERROR = createAction(
  'customerInsights/GET_CUSTOMER_INSIGHTS_ERROR'
);
export const SET_CUSTOMER_INSIGHTS_LOADING = createAction(
  'customerInsights/SET_CUSTOMER_INSIGHTS_LOADING'
);
export const CLEAR_CUSTOMER_INSIGHTS = createAction(
  'customerInsights/CLEAR_CUSTOMER_INSIGHTS'
);
